import styled from 'styled-components';
import { AddUser } from '@styled-icons/entypo/AddUser'
import { SearchAlt2 } from '@styled-icons/boxicons-regular/SearchAlt2'
import { Add } from '@styled-icons/material/Add'


import { Link } from 'react-router-dom';

export const LinkItem = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &:hover {
    div {
      box-shadow: 0 6px 20px rgba(0, 0, 0, .16);
    }
    h3 {
      color: ${props => props.to === '/signup' ? '#CE1717' : '#1FA528' };
    }
    svg path:first-child {
      fill: ${props => props.to === '/signup' ? '#CE1717' : '#1FA528' };
      ;
    }
  }

  @media only screen and (max-width: 768px) {
    margin: 0;
  }
`;

export const LinkIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #FFF;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .16);

  @media only screen and (max-width: 768px) {
    width: 100px;
    height: 100px;
  }
`;

export const AddIcon = styled(AddUser)`
  color: #0B4683;
  width: 100px;
  height: 100px;
  
  @media only screen and (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`;

export const SearchIcon = styled(SearchAlt2)`
  color: #0B4683;
  width: 120px;
  height: 120px;

  @media only screen and (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;

export const AddUs = styled(Add)`
  color: #0B4683;
  width: 130px;
  height: 130px;

  @media only screen and (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;

export const LinkText = styled.h3`
  margin-top: 10px;

  font-weight: normal;
  font-size: 2.375rem;
  text-transform: Capitalize;
  text-align: center;
  line-height: 2.5rem;
  color: #0B4683;
  width: 80%;

  @media only screen and (max-width: 768px) {
    font-size: 1.5rem;
    width: 100%;
    margin-bottom: 20px;
  }
`;